/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import ReactQuill from "react-quill";

function DescriptionCard({description}) {
  return (
    <Card>
      <MDBox display="flex" justifyContent="space-between" alignItems="center" pt={3} mb={2} px={3}>
          <MDTypography variant="h6" fontWeight="medium">
              Description
          </MDTypography>
        {/*<MDBadge variant="contained" color="info" badgeContent="moderate" container />*/}
      </MDBox>
      <MDBox pb={3} px={3}>
        <MDTypography component="span" variant="body2" color="text">
            <ReactQuill theme="bubble" value={description?description:""} readOnly={true}  />
        </MDTypography>
      </MDBox>
    </Card>
  );
}

export default DescriptionCard;
